import bannerImg from './banners/woman-helping-man-gym.jpg';

const satisfacaoPosConsulta = (t) => ({
    id: 'satisfacao-pos-consulta',
    title: t('templates.items.satisfacaoPosConsulta.title'),
    description: t('templates.items.satisfacaoPosConsulta.description'),
    indicatedFor: t('templates.audiences.nutritionists'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.satisfacaoPosConsulta.summary.consultationScore'),
        t('templates.items.satisfacaoPosConsulta.summary.guidanceClarity'),
        t('templates.items.satisfacaoPosConsulta.summary.improvementPoints'),
        t('templates.items.satisfacaoPosConsulta.summary.wouldRecommend'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.satisfacaoPosConsulta.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.satisfacaoPosConsulta.form.opinion.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.satisfacaoPosConsulta.form.opinion.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: t('templates.items.satisfacaoPosConsulta.form.opinion.rating.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.satisfacaoPosConsulta.form.opinion.rating.minLabel'),
                            maxLabel: t('templates.items.satisfacaoPosConsulta.form.opinion.rating.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'scale',
                        label: t('templates.items.satisfacaoPosConsulta.form.opinion.clarity.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.satisfacaoPosConsulta.form.opinion.clarity.minLabel'),
                            maxLabel: t('templates.items.satisfacaoPosConsulta.form.opinion.clarity.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: t('templates.items.satisfacaoPosConsulta.form.opinion.improve.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'yes_no_maybe',
                        label: t('templates.items.satisfacaoPosConsulta.form.opinion.recommend.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default satisfacaoPosConsulta;
